import './styles.scss';
import React from 'react';
import {IContractAnalyticsResponse} from "../../../api/Contract/Contract.types";
import {Collapse, List} from "antd";
import ANALYTICS_COMPONENT_MAP from "./Contracts.analytics.componentMap";
import {StringUtils} from "../../../global/utils/string";
import ContractsRankedVendorsGraph from "../Contracts.graphs/Contracts.graphs.rankedVendors";
import {FunnelPlotOutlined, PieChartOutlined} from "@ant-design/icons";

interface Props {
    analytics: IContractAnalyticsResponse
}

function ContractsAnalytics({analytics}: Props) {

    function renderAnalyticsGraph(key) {
        let Graph = ANALYTICS_COMPONENT_MAP[key];
        if (!analytics[key]) {
            return null;
        } else {
            return (
                <List.Item style={{height: 350}} className='single-analytics-graph'>
                    <div className='graph-title'>
                        {StringUtils.camelCaseToRegular(key)}
                    </div>
                    <Graph data={analytics[key].data}/>
                </List.Item>
            )
        }
    }

    return (
        <div className='contracts-analytics'>
            <Collapse expandIconPosition='right'>
                <Collapse.Panel key={1}
                                header={<div className='collapse-header'><PieChartOutlined/> Graphing Analytics</div>}>
                    <List dataSource={Object.keys(ANALYTICS_COMPONENT_MAP)} grid={{
                        gutter: 16,
                        xs: 1,
                        sm: 1,
                        md: 1,
                        lg: 1,
                        xl: 1,
                        xxl: 2,
                    }} renderItem={renderAnalyticsGraph}/>
                </Collapse.Panel>
                <Collapse.Panel key={2}
                                header={<div className='collapse-header'><FunnelPlotOutlined/> Ranked Vendor List
                                </div>}>
                    <div className='ranked-vendors-graph-container'>
                        <ContractsRankedVendorsGraph data={analytics?.rankedVendors?.data}/>
                    </div>
                </Collapse.Panel>
            </Collapse>

        </div>
    )
}

export default ContractsAnalytics;